import React from 'react'
import NumberFormat from 'react-number-format'

const TextNumberFormat = (props) => {
  const {
    thousandSeparator = '.',
    decimalSeparator = ',',
    inputOrText = 'input',
    decimalScale = 2,
    type = 'text',
    onChange,
    id,
    customInput,
    className,
    name,
    invalid,
    ...rest
  } = props

  const [value, setValue] = React.useState(props.defaultValue)

  return (
    <NumberFormat
      id={id}
      name={name}
      defaultValue={isNaN(value) ? 0 : value}
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      isNumericString={true}
      displayType={inputOrText}
      decimalScale={decimalScale}
      type={type}
      allowNegative={false}
      onValueChange={values => {
        setValue(values.floatValue)
        if (onChange) onChange(values.floatValue)
      }}
      customInput={customInput}
      className={className}
      invalid={invalid}
      {...rest}
    />
  )

}

export default TextNumberFormat
